<template>
    <div class="dashboard-page">
        <BasePageTitle :title="tokens.fullScreen.dashboard" />
        <BasePanel>
            <template #content>
                <div class="dashboard-top">
                    <DashboardAccounts class="dashboard-accounts" />
                    <AccountInfoList class="account-info" />
                    <div class=success-rate>
                        <div class="title label__large">{{ tokens.fullScreenDashboard.successRate }}</div>
                        <BasePieChart />
                    </div>
                </div>
            </template>
        </BasePanel>
        <BasePanel>
            <template #content>
                <BaseLineChartNew />
            </template>
        </BasePanel>
    </div>
</template>

<script>
import BasePageTitle from "@/new-design/shared/ui/titles/BasePageTitle.vue"
import BasePanel from "@/new-design/shared/ui/panels/BasePanel.vue"
import AccountInfoList from "@/new-design/features/Dashboard/ui/AccountInfoList.vue"
import DashboardAccounts from "@/new-design/features/Dashboard/ui/DashboardAccounts.vue"
import BasePieChart from "@/new-design/shared/ui/charts/BasePieChart.vue"
import BaseLineChartNew from "@/new-design/shared/ui/charts/BaseLineChartNew.vue"
import {mapGetters} from "vuex";

export default {
    name: "DashboardPage",
    components: { BasePageTitle, BasePanel, AccountInfoList, DashboardAccounts, BasePieChart, BaseLineChartNew },
    computed: {
        ...mapGetters(['tokens'])
    }
}
</script>

<style scoped>
.panel {
    padding: 0;
    border: none !important;
    margin-bottom: 12px;
}

.dashboard-top {
    display: grid;
    grid-template-columns: 1fr 1fr 220px;
    grid-template-rows: 1fr 1fr 1fr;
    grid-gap: 12px 16px;
}

.dashboard-accounts {
    grid-column: 3/4;
    grid-row: 1/4;
}

.account-info {
    grid-column: 1/3;
    grid-row: 1/2;
}

.success-rate {
    grid-column: 1/3;
    grid-row: 2/4;
    border-radius: 8px;
    border: 1px solid var(--System-OutlineVariant);
}

.success-rate .title {
    padding: 16px 12px;
    color: var(--System-OnSurfaceVariant);
}

@media(max-width: 1023px) {
    .dashboard-top {
        grid-template-columns: 1fr;
        grid-template-rows: auto
    }

    .dashboard-accounts,
    .account-info,
    .success-rate {
        grid-column: 1/3;
        grid-row: auto;
    }

    .dashboard-page {
        padding-bottom: 26px;
    }
}
</style>
